import type { Composition } from '@spreadgroup/common-partner-lib/composition';

/**
 * Whether a composition has anything a sample could be made of — the only condition on the
 * composition itself, since the journey samples `composition.sellables`.
 *
 * Deliberately blind to the product-setup mode, everywhere and not just outside the publishing
 * journey (DEV-231131 → review of !155). UNSUPPORTED restricts *editing*, and ordering a sample is
 * not editing: the mode is about `assortmentRule` and `templateProducts`, neither of which the
 * journey reads. Gating on it only meant the button hid itself on a composition page while the same
 * composition stayed reachable through the entry dialog.
 *
 * Which scopes are switched on is a separate, rollout question and lives in
 * `sampleOrderAvailability.ts`, so this rule stays about the composition alone.
 */
export const hasSampleableProducts = (
  composition: Composition | null | undefined,
): composition is Composition => !!composition?.sellables.length;
